import Vue from 'vue'
import Router from 'vue-router'
import index from './views/index.vue';
Vue.use(Router);



export default new Router({
    mode:'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'index',
            component: index,
            meta: {
                title: '首页 - 清洁空气政策伙伴关系CCAPP',
            },

        },
        {
            path: '/index',
            component: index,
            meta: {
                title: '首页 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/aboutUs',
            component: () => import('./views/AboutUsPage.vue'),
            meta: {
                title: '关于我们 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/job',
            component: () => import('./views/JobAndStudy.vue'),
            meta: {
                title: '关于我们 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/experience/:id',
            name:'experience',
            component: () => import('./views/WorkExperiencePage.vue'),
            meta: {
                title: '关于我们 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/frame',
            component: () => import('./views/FramePage.vue'),
            meta: {
                title: '关于我们 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/figure/:id',
            name: 'figure',
            component: () => import('./views/FigurePage.vue'),
            meta: {
                title: '关于我们 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/figureInfo/:id',
            name: 'figureInfo',
            component: () => import('./views/FigureInfoPage.vue'),
            meta: {
                title: '关于我们 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/partners',
            component: () => import('./views/PartnersPage.vue'),
            meta: {
                title: '合作伙伴 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/partner',
            component: () => import('./views/PartnerPage.vue'),
            meta: {
                title: '合作伙伴 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/resources/:id/:category',
            name: 'Resources',
            component: () => import('./views/ResourcesPage.vue'),
            meta: {
                 title:"首页",
            	 showInbreadcrumb:true
            },
           


        },
        {
			path: '/resource/:id',
			name:'resource',
			component: () => import('./views/ResourcePage.vue'),
			meta: {
				title: '资源详情 - 2',
				showInbreadcrumb:true
			}
		},
        
        {
            path: '/resources/:id',
            component: () => import('./views/ResourcesPage.vue'),
            meta: {
                title: '资源 2',
                 title2: '资源 4',
            },
        },
       
        {
            path: '/report/:id',
            name:'report',
            component: () => import('./views/ReportPage.vue'),
            meta: {
                title: '报告 - 清洁空气政策伙伴关系CCAPP',
            },
        },
         {
            path: '/search',
            component: () => import('./views/SearchPage.vue'),
            meta: {
                title: '搜索 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/reportInfo/:id',
            name: 'reportInfo',
            component: () => import('./views/ReportInfoPage.vue'),
            meta: {
                title: '报告详情 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/news/:id/:category',
            name:'NewsPage',
            component: () => import('./views/NewsPage.vue'),
            meta: {
                title: '新闻活动 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/news/:id',
            name:'NewsPage',
            component: () => import('./views/NewsPage.vue'),
            meta: {
                title: '新闻活动 - 清洁空气政策伙伴关系CCAPP',
            },
        },
        {
            path: '/newsInfo/:id',
            name: 'newsInfo',
            component: () => import('./views/NewsInfoPage.vue'),
            meta: {
                title: '新闻活动 - 清洁空气政策伙伴关系CCAPP',
            },
        }

    ]
})
